import { useEffect, useMemo, useRef } from "react";
import { NotificationItem, useNotificationStore } from "@/stores/notifications/notificationStore";

export function useVisibleNotifications(
  stack: NotificationItem[],
  maxVisibleNotifications: number,
) {
  const { removeNotification } = useNotificationStore();
  const timeoutRefs = useRef<Map<string, NodeJS.Timeout>>(new Map());

  const visibleNotifications = useMemo(
    () => stack.slice(0, maxVisibleNotifications),
    [maxVisibleNotifications, stack],
  );

  useEffect(() => {
    // Clear timeouts for notifications that were removed by clicking
    const currentIds = new Set(stack.map((item) => item.id));
    timeoutRefs.current.forEach((timeout, id) => {
      if (!currentIds.has(id)) {
        clearTimeout(timeout);
        timeoutRefs.current.delete(id);
      }
    });

    visibleNotifications.forEach((item) => {
      if (!timeoutRefs.current.has(item.id)) {
        const timeout = setTimeout(() => {
          removeNotification(item.id);
          timeoutRefs.current.delete(item.id);
        }, 5000);

        timeoutRefs.current.set(item.id, timeout);
      }
    });
  }, [stack, removeNotification, visibleNotifications]);

  return {
    visibleNotifications,
    removeNotification,
  };
}
